import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ProgressBarService } from '../header/progress-bar/progress-bar.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent   {
  hidden: boolean;

  constructor(public _translate: TranslateService,private _http: HttpClient, private _progressBarService: ProgressBarService,public dialogRef: MatDialogRef<AlertComponent>,) { }



  hide() {
    // this.hidden = true;
    this.dialogRef.close('fix');
  }


  downloadFile(url: string): Observable<Blob> {
    return this._http.get(url, { responseType: 'blob' });
  }

  downloadPrinterApp() {
    const fileUrl = 'https://khdma-production-bucket.s3.eu-west-2.amazonaws.com/setup/5dma-printers-v1.exe';
    this._progressBarService.show();
    this.downloadFile(fileUrl).subscribe(blob => {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = '5dma-printers-v1.exe';
      a.click();
      URL.revokeObjectURL(objectUrl);
    }, error=> {console.log(error); {
      console.log('Error downloading PDF');
    }});
    this._progressBarService.hide();
    this.dialogRef.close('fix');
  }
}
